import { useNavigate, useParams } from 'react-router-dom'
import { Typography, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'

import EmptyScreen from 'packages/ui/EmptyScreen'
import ScrollTable from 'components/global/CUK/ScrollTable'
import TableView, { useTable, IItem, IColumn } from 'packages/ui/Table'
import TableSkeleton from 'components/global/CUK/Skeletons/TableSkeleton'

import { useSort, useSelection } from '../store'
import useList, { IBypass } from '../use-bypass'
import COLUMNS_CONFIG from './columns-config'
import React from 'react'


const Table = () => {
  const navigate = useNavigate()
  const [selection, setSelection] = useSelection()
  const {id} = useParams()
  const apiList = useList()
  const [sort, setSort] = useSort()
  const {t} = useTranslation()
  const apiTable = useTable({
    rowKey: 'id',
    loading: apiList.loading,
    loadingNext: apiList.loadingNext,
    items: apiList.items as unknown as IItem[],
    columns: COLUMNS_CONFIG,
    onRowClick: (item) => {
      if (selection.length) {
        const exist = selection.some(({id}) => id === item.id)
        if (exist) {
          setSelection(prev => prev.filter(({ id }) => id !== item.id))
        } else {
          setSelection(prev => [...prev, item as unknown as IBypass]);
        }
      } else {
        navigate(`/bypass/${item.id}`)
      }
    }
  })
  if (apiList.error) {
    return (
      <EmptyScreen icon="wifi">{t(`api_errors.${apiList.error}`)}</EmptyScreen>
    )
  }
  if (!apiList.loading && !apiList.items.length) {
    return (
      <EmptyScreen icon="wifi">{t('bypass.no_data_filter')}</EmptyScreen>
    )
  }
  return (
    <ScrollTable
      fetchNextPage={apiList.fetchNextPage}
      shouldFetchNextPage={apiList.shouldFetchNextPage}
      collapse={Boolean(id)}
    >
      {
        apiList.loading
          ? <TableSkeleton />
          : apiList.error
            ? <Stack justifyContent={'center'} alignItems={'center'} sx={{height: '100%'}}><Typography component={'span'} sx={{fontSize: 12, paddingLeft: 1}} color={'error'}>{t(`errors.${apiList.error}`)}</Typography></Stack>
            : <TableView
                apiTable={apiTable}
                sort={{
                  ...sort,
                  direction: sort.direction as string,
                  by: sort.by as string,
                  onChange: name => {
                    const column = COLUMNS_CONFIG.find(column => column.name === name) as IColumn
                    setSort(column?.sortBy || column?.name)
                  }
                }}
              />
      }
    </ScrollTable>
  )
}

export default Table